export const ADD_ON_SUBSCRIPTION_FUNNEL_STARTED_EVENT = 'add_on_subscription_funnel_started';
